import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  AnalyticsService,
  AuthorizationService,
  LoggingService,
  TimePeriod,
} from "app/shared";
import { BaseDetailsLogic } from "app/analytics/BaseDetailsLogic";
import { ManualsDownloadedLeastConfig } from "app/shared/model/charts/user-analytic-configurations.model";
import { TooltipCoordinatorService } from "app/analytics/services/tooltip-coordinator.service";

@Component({
  selector: "manuals-downloaded-least-details",
  templateUrl: "./manuals-downloaded-least-details.component.html",
  standalone: false,
})
export class ManualsDownloadedLeastDetailsComponent
  extends BaseDetailsLogic<ManualsDownloadedLeastConfig>
  implements OnInit, OnDestroy
{

  constructor(
    analyticsService: AnalyticsService,
    authService: AuthorizationService,
    loggingService: LoggingService,
    tooltipCoordinator: TooltipCoordinatorService
  ) {
    super(analyticsService, authService, loggingService, ManualsDownloadedLeastConfig, tooltipCoordinator);
  }

  get selectedTimePeriod(): string | TimePeriod {
    return this.config?.period as TimePeriod;
  }

  set selectedTimePeriod(value: string | TimePeriod) {
    this.config.period = value;
    this.detectSettingsChange();
    this.refreshDataFromFilters();
  }

  get selectedNumberResults(): number {
    return this.config?.bottom || 10;
  }

  set selectedNumberResults(value: number) {
    this.config.bottom = value;
    this.detectSettingsChange();
    this.refreshDataFromFilters();
  }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
  }

  protected getInfoTexts(): { [key: string]: string } {
    return {
      timePeriod: 'Pick a time period to see which manuals were downloaded the least during that time. For example, you can look at the least downloaded manuals from the last month or year. This helps you find manuals that might need more attention or promotion.',
      numberResults: 'Set how many manuals you want to see in the list. For example, if you enter 10, you will see the 10 manuals with the fewest downloads. This helps you focus on the least popular manuals so you can decide what to improve.'
    };
  }
}
